<template>
  <div class="widget widget-shadow white" v-bind:class="data.Color">
    <div class="widget-content padding-30">
      <div class="counter counter-lg counter-inverse text-left">
        <div class="counter-label margin-bottom-20">
          <div>{{ data.Text_1 }}</div>
        </div>
        <div class="counter-number-group margin-bottom-15">
          <span class="counter-number">{{ data.Text_2 }}</span>
        </div>
        <div class="counter-label">
          <div class="progress progress-xs margin-bottom-10 bg-blue-800">
            <div class="progress-bar progress-bar-info bg-white"
                 v-bind:style="data.style"
                 aria-valuemax="100"
                 aria-valuemin="0"
                 v-bind:aria-valuenow="data.Number"
                 role="progressbar">
              <span class="sr-only">{{ data.Number }}</span>
            </div>
          </div>
          <div class="counter counter-sm text-left">
            <div class="counter-number-group">
              {{ data.Text_3 }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:  'DailyPanel',
  props: ['item'],
  data () {
    return {
      data: {}
    }
  },

  created () {
    if (!this.item.FieldValues) {
      return
    }

    this.data       = JSON.parse(this.item.FieldValues[0].JSON)
    this.data.style = 'width: ' + this.data.Number + '%'
  }
}
</script>

<style scoped>
.padding-30 {
  padding: 30px !important;
}
</style>
